import { render, staticRenderFns } from "./VcargoclearanceactionsGrid.vue?vue&type=template&id=441d4880"
import script from "./VcargoclearanceactionsGrid.vue?vue&type=script&lang=js"
export * from "./VcargoclearanceactionsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports